import { Outlet, Link } from 'react-router';

export function AuthLayout() {
  return (
    <div className="grid min-h-screen grid-cols-1 bg-(--color-bg) text-(--color-fg) lg:grid-cols-2">
      <section className="flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-md">
          <Link to="/" className="mb-8 inline-flex items-center gap-2 font-display text-2xl font-bold">
            <span aria-hidden className="inline-block h-6 w-6 rounded-md bg-(--color-accent)" />
            Organiza.AI
          </Link>
          <Outlet />
        </div>
      </section>
      <aside
        className="hidden items-center justify-center bg-(--color-surface) p-10 lg:flex"
        aria-hidden
      >
        <div className="max-w-md">
          <h2 className="font-display text-3xl font-semibold">
            Controle sua produção médica em minutos.
          </h2>
          <p className="mt-4 text-(--color-fg-muted)">
            Calendário, quick-tap de procedimentos, conferência fiscal automática e NFS-e emitida
            sem abrir portal da prefeitura. Feito para plantonistas PJ.
          </p>
        </div>
      </aside>
    </div>
  );
}
